import { render, staticRenderFns } from "./RecurringRemarkModal.vue?vue&type=template&id=39ca1eae"
import script from "./RecurringRemarkModal.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports